import moment from 'moment'

class Helper {
  static ShowToastCatchError(error) {
    if (error && error.response && error.response.data && error.response.data.error) {
      return error.response.data.error || '-'
    } else if (error && error.message) {
      return error.message || '-'
    } else {
      return error || '-'
    }
  }
  static FormatNumberLength(num, length) {
    var r = "" + num;
    while (r.length < length) {
      r = "0" + r;
    }
    return r;
  }
  static toCurrency(n) {
    if (n) {
      n = parseFloat(n);
      return n.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else {
      return '0.00';
    }
  }
  static toArabic(n) {
    if (n) {
      n = parseFloat(parseFloat(n).toFixed(2));
      if (n % 1 != 0)
        return n.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      else
        return n.toFixed().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else {
      return '0';
    }
  }

  static splitArrayIntoChunks(arr, chunkLen) {
    var chunkList = []
    var chunkCount = Math.ceil(arr.length / chunkLen)
    for (var i = 0; i < chunkCount; i++) {
      chunkList.push(arr.splice(0, chunkLen))
    }
    return chunkList
  }
  static headerDateFormat(data) {
    if (data.split("-").length > 1)
      return this.$moment(data, "YYYY-MM").format("MMMM YYYY")
    else
      return data
  }
  static yearFormat(data) {
    return data
  }
  static datelabel(date) {
    if (date)
      return `${moment(date).format("D MMMM YYYY")}`;
    else
      return ``;
  }
  static dhm(s) {
    if (!s) return '0:0:0:0'
    const days = Math.floor(s / (24 * 60 * 60));
    const dayss = s % (24 * 60 * 60);
    const hours = Math.floor(dayss / (60 * 60));
    const hourss = s % (60 * 60);
    const minutes = Math.floor(hourss / (60));
    const minutess = s % (60);
    const sec = Math.floor(minutess);
    return days + ":" + hours + ":" + minutes + ":" + sec;
  }
  static roundNumber(num, n = 2) {
    let res = 0
    if (num)
      res = Math.round((num || 0) * (10 ^ n)) / (10 ^ n)
    return parseFloat(res.toFixed(n));
  }
  static round(num, isDecimal = true) {
    if (num)
      return isDecimal ? Math.round((num || 0) * 100) / 100 : Math.round(num || 0)
    return 0
  }
  static roundFacilityCost(cost) {
    var a1 = Math.floor(cost);
    var a2 = 0;
    if (cost % 1 < 0.1) a2 = 0;
    else if (cost % 1 < 0.3) a2 = 0.25;
    else if (cost % 1 < 0.6) a2 = 0.5;
    else if (cost % 1 < 0.8) a2 = 0.75;
    else a2 = 1;
    return a1 + a2;
  }
  // static numberToText(num) {
  //   var dg = ['ศูนย์', 'หนึ่ง', 'สอง', 'สาม', 'สี่', 'ห้า', 'หก', 'เจ็ด', 'แปด', 'เก้า'];
  //   let text = ""
  //   let numInt;
  //   if (num || num == 0) {
  //     let tempNum = parseFloat(num)
  //     if (tempNum >= 0) {
  //       numInt = Math.floor(tempNum)
  //     } else {
  //       text = "ลบ"
  //       numInt = Math.ceil(tempNum) * -1
  //     }
  //     text += ThaiBaht(numInt).split('บาทถ้วน')[0]
  //     let str = tempNum.toString()
  //     if (str.split('.') && str.split('.')[1]) {
  //       let strArray = str.split('.')[1].split('')
  //       text += 'จุด' + strArray.map(d => { return dg[d] }).join('')
  //     }
  //   }
  //   return text || ""
  // }
  // static thaiBaht(num) {
  //   if (num || num == 0)
  //     return ThaiBaht(parseFloat(num))
  //   else
  //     return ""
  // }
  static timeLabel(step = 30) {
    let stepLabel = [15, 30, 60]
    let hours = 24
    let minutes = 60

    let res = {
      hours: [],
      minutes: [],
      hoursMinutes: []
    }
    if (stepLabel.includes(step)) {
      for (let ih = 0; ih < hours; ih++) {
        res.hours.push(ih)
        let stepUp = 0
        for (let im = 0; im < minutes / step; im++) {
          res.minutes.push(stepUp)
          res.hoursMinutes.push(`${String(ih).padStart(2, '0')}:${String(stepUp).padStart(2, "0")}`)
          stepUp += step
        }
      }
    }
    return res
  }
  static queryMore(func, params) {
    var objects = [];
    let fetchAllIgnoringLimit = async function (func, params, result) {
      const limit = 1000;
      const skip = result.length;

      params = {
        ...params,
        limit,
        skip
      }

      const results = await func(params)
      result = result.concat(results)

      if (results.length === limit) {
        return await fetchAllIgnoringLimit(func, params, result);
      } else {
        return result;
      }
    }
    return fetchAllIgnoringLimit(func, params, objects)
  }
  static formatNumberLength(num, length) {
    var r = "" + num;
    while (r.length < length) {
      r = "0" + r;
    }
    return r;
  }
  static dayMonthYearText(startDate, endDate) {
    let days = 0;
    let months = 0;
    let years = 0;
    let text = "";
    if (startDate && endDate) {
      let a = moment(endDate);
      let b = moment(startDate);
      a.add(1, "days");
      years = a.diff(b, "year");
      b.add(years, "years");
      months = a.diff(b, "months");
      b.add(months, "months");
      days = a.diff(b, "days");
    }
    if (years) {
      text += `${years} ปี `;
    }
    if (months) {
      text += `${months} เดือน `;
    }
    if (days) {
      text += `${days} วัน`;
    }
    return text;
  }
  static langToFullLang(lang) {
    let fullLang = null
    if (lang == 'th') fullLang = 'th-TH'
    if (lang == 'lo') fullLang = 'lo-LA'
    if (lang == 'en') fullLang = 'en-US'
    return fullLang
  }
}
export default Helper